import { faTrophy } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { styled } from 'styled-components'

import {
  FormattedMessage,
  Tag,
  TagFormat,
  TagType,
} from '@b-stock/fe-core/bstock-react'
import { Colors } from '@b-stock/fe-core/design-system'

import type { SearchResult } from '@/queries/listingSearchQuery'

import { useCardFirstDibsWindowEnd } from './useCardFirstDibsWindow'

const StyledTag = styled(Tag)`
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding-top: 4px;
  padding-bottom: 4px;
  background-color: ${Colors.Semantic.BStock.default.lightBackground};
  color: ${Colors.Semantic.Neutral.white};
  white-space: nowrap;
`

/** "First Dibs" tag next to the buying format while the buyer's window is open. */
const FirstDibsTag = ({ listing }: { listing: SearchResult }) => {
  const windowEnd = useCardFirstDibsWindowEnd(listing)

  if (!windowEnd) return null

  return (
    <StyledTag
      format={TagFormat.type}
      type={TagType.normal}
      data-testid="first-dibs-tag"
    >
      <FontAwesomeIcon icon={faTrophy} size="xs" />
      <FormattedMessage id="FirstDibs.card.tag" />
    </StyledTag>
  )
}

export default FirstDibsTag
